import React from 'react';
import PropTypes from 'prop-types';
import { DOTS_TYPE, LOADING_CLASSNAME, SPINNER_TYPE } from './constants';
import { getLoaderType } from './helpers';
const Loading = ({
  type
}) => {
  const loaderType = getLoaderType(type);
  const CLASSNAME = `${LOADING_CLASSNAME}__${loaderType}`;
  return /*#__PURE__*/React.createElement("div", {
    className: CLASSNAME
  }, loaderType === DOTS_TYPE && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${CLASSNAME}__dot`
  }), /*#__PURE__*/React.createElement("div", {
    className: `${CLASSNAME}__dot`
  }), /*#__PURE__*/React.createElement("div", {
    className: `${CLASSNAME}__dot`
  })));
};
Loading.propTypes = {
  type: PropTypes.string
};
Loading.defaultProps = {
  type: SPINNER_TYPE
};
export default Loading;
//# sourceMappingURL=Loading.js.map